module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAASVl2WAAABL0lEQVR4AWyOvUoDURCFz9w1QdBOtDOlhS9gaxULGxuxFwKiRHC9JCyxuMWywv6IsgoiapEHsBMEC30AX8BGsBDFTiMB/3acu+hiSIYZOHPnuzNHYUC4bjCltZmwoz7Adf1JDOGSqXRV94LxHmDNC8aopC4IqAD0hLfH1wLQOhoZ/sI5GNMM3DjkLKRp+p4Di8aUM+fzDIQZgG9V9jEfhs0OJJQxRlW65TYxqvL7Ad88F8fmWWZ5qk63lIpaknpBhmqSbN2LLtKeuJOOmTFKjj0h3b9USdhKwLwhb0rMHetmUBNdpN2AJGrtibm6bCGpw82Gv/pH5IBtdqLWAYFWrGZW+27DX7e6AGyTRN6RmKkRiV1Wu1pvz/YAFpJNpwItE/gkjr3rPuAXaouv3OwPAAAA//+3Z5BFAAAABklEQVQDAEe+ah2DdTcEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/left-arrow.png
// module id = cHZG
// module chunks = 2